(function () {
  // --------------------------------------------
  // Supply Infinite Scroll — page-count driven
  // Fixed 2026-09: (1) no early stop when a page adds nothing new,
  // (2) no ?page= rewrite (refresh used to reload mid-collection),
  // (3) re-check the sentinel after each load (no stalls),
  // (4) reconcile pass: re-sweeps pages to catch products that moved between
  //     pages (unstable Best selling / Newest order) until all are shown.
  // --------------------------------------------

  const HARD_LOCK_GRID_SELECTOR = '.grid-uniform';
  const DEBUG = /(^|[?&])infdebug=1(&|$)/.test(location.search);
  const dlog = (...a) => { if (DEBUG) console.log('[INF]', ...a); };

  const sentinel = document.getElementById('tt-inf-scroll-sentinel');
  const loadMoreBtn = document.getElementById('tt-load-more');
  if (!sentinel) { dlog('No sentinel; exiting'); return; }

  // Total pages, from the hidden input rendered by the section
  const totalPages = (() => {
    const el = document.querySelector('.eosh-total-pages');
    const n = el ? parseInt(el.value || el.getAttribute('value') || '1', 10) : 1;
    return isNaN(n) ? 1 : Math.max(1, n);
  })();

  // Products the collection really has on the storefront (0 = unknown)
  const expectedTotal = (() => {
    const el = document.querySelector('.tt-total-products');
    const n = el ? parseInt(el.value || el.getAttribute('value') || '0', 10) : 0;
    return isNaN(n) ? 0 : n;
  })();

  // Page this document was rendered at (?page=), default 1
  const startUrl = new URL(location.href);
  let currentPage = parseInt(startUrl.searchParams.get('page') || '1', 10);
  if (!currentPage || currentPage < 1) currentPage = 1;
  dlog('totalPages=', totalPages, 'currentPage=', currentPage, 'expected=', expectedTotal);

  function pageUrl(p) {
    const u = new URL(location.href);
    u.searchParams.set('page', String(p));
    return u.pathname + u.search;
  }

  const SEEN_PRODUCT_KEYS = new Set();

  function detectGrid(root = document) {
    if (HARD_LOCK_GRID_SELECTOR) {
      const el = root.querySelector(HARD_LOCK_GRID_SELECTOR);
      if (el) return el;
    }
    const candidates = ['#product-grid','.grid-uniform','.product-grid','.collection-grid','[data-products]','[data-section-type="collection-template"] .grid','main .grid','main [role="list"]'];
    for (const sel of candidates) {
      const el = root.querySelector(sel);
      if (el && el.children && el.children.length >= 2) return el;
    }
    let best=null,bestScore=0;
    root.querySelectorAll('.grid, .grid-uniform, [id*="grid"], [class*="grid"]').forEach(el=>{
      const s = el.children?el.children.length:0;
      if (s>bestScore){best=el;bestScore=s;}
    });
    return best;
  }

  const grid = detectGrid(document);
  if (!grid) {
    dlog('No grid found — showing Load more fallback.');
    if (loadMoreBtn) loadMoreBtn.style.display = 'inline-block';
    return;
  }

  const ITEM_SELECTOR = '.grid-item, .grid__item';

  function productKeyFromElement(el) {
    const link = el.querySelector('a[href*="/products/"]');
    if (link) {
      try {
        const u = new URL(link.getAttribute('href'), location.origin);
        return u.pathname.replace(/\/+$/,'');
      } catch(_) {}
    }
    const pid = el.getAttribute?.('data-product-id') || el.getAttribute?.('data-productid');
    if (pid) return 'id:'+pid;
    return null; // not a product card: don't count it
  }

  function productCount() { return SEEN_PRODUCT_KEYS.size; }

  // Seed with what's already on the first rendered page
  Array.from(grid.querySelectorAll(ITEM_SELECTOR)).forEach(el=>{
    const k = productKeyFromElement(el);
    if (k) SEEN_PRODUCT_KEYS.add(k);
  });

  function parseHTML(html){
    const tmp = document.implementation.createHTMLDocument('');
    tmp.documentElement.innerHTML = html;
    return tmp;
  }

  function appendNewItems(fromDoc){
    const nextGrid = detectGrid(fromDoc);
    if (!nextGrid) return 0;
    const items = nextGrid.querySelectorAll(ITEM_SELECTOR);
    let added = 0;
    const frag = document.createDocumentFragment();
    items.forEach(el=>{
      const key = productKeyFromElement(el);
      if (!key || SEEN_PRODUCT_KEYS.has(key)) return;
      SEEN_PRODUCT_KEYS.add(key);
      frag.appendChild(el.cloneNode(true));
      added++;
    });
    if (added) grid.appendChild(frag);
    dlog(`Appended ${added} new items (total ${productCount()})`);
    return added;
  }

  async function fetchPage(p){
    const res = await fetch(pageUrl(p), { credentials: 'same-origin' });
    if (!res.ok) throw new Error('HTTP '+res.status);
    return parseHTML(await res.text());
  }

  let loading=false, done=false;

  function sentinelNear(){
    const r = sentinel.getBoundingClientRect();
    return r.top < (window.innerHeight || 800) + 900;
  }

  async function loadNextPage(){
    if (loading || done) return;
    if (currentPage >= totalPages) { await reconcile(); return; }

    loading = true;
    const next = currentPage + 1;
    dlog('Fetching page', next);
    try {
      const doc = await fetchPage(next);
      appendNewItems(doc);              // 0 new items is fine: keep going
      currentPage = next;               // (no ?page= rewrite: refresh starts at page 1)
      if (currentPage >= totalPages) { loading = false; await reconcile(); return; }
    } catch(e) {
      console.warn('Infinite scroll error:', e);
      if (loadMoreBtn) loadMoreBtn.style.display='inline-block';
    } finally {
      loading = false;
    }
    // Sentinel still in range after appending? Load the next page now (no stall)
    if (!done && sentinelNear()) setTimeout(loadNextPage, 60);
  }

  // After the last page: if products are missing (they moved between pages
  // while loading), sweep the pages again, adding only what's missing.
  async function reconcile(){
    if (done) return;
    loading = true;
    let passes = 0;
    while (expectedTotal && productCount() < expectedTotal && passes < 2) {
      passes++;
      dlog('Reconcile pass', passes, 'have', productCount(), 'of', expectedTotal);
      for (let p = 1; p <= totalPages && productCount() < expectedTotal; p++) {
        try { appendNewItems(await fetchPage(p)); } catch(e) { dlog('Reconcile fetch failed', p, e); }
      }
    }
    loading = false;
    finish();
  }

  function finish(){
    done=true;
    sentinel && (sentinel.style.display='none');
    loadMoreBtn && (loadMoreBtn.style.display='none');
    observer && observer.disconnect();
    dlog('Finished —', productCount(), 'products shown');
  }

  const observer = ('IntersectionObserver' in window)
    ? new IntersectionObserver((entries)=>{
        entries.forEach(entry=> entry.isIntersecting && loadNextPage());
      }, { rootMargin:'900px 0px 900px 0px', threshold:0 })
    : null;

  observer && observer.observe(sentinel);
  loadMoreBtn && loadMoreBtn.addEventListener('click', loadNextPage);

  if (DEBUG){
    const panel=document.createElement('div');
    panel.style.cssText='position:fixed;bottom:16px;right:16px;z-index:9999;background:#111;color:#fff;padding:10px 12px;border-radius:10px;font:12px/1.4 system-ui';
    panel.innerHTML = `
      <div><strong>Infinite Scroll Debug</strong></div>
      <div>Pages: <code>${totalPages}</code> · Expected products: <code>${expectedTotal}</code></div>
      <div>Shown: <code id="inf-count">${productCount()}</code></div>
      <button id="inf-next" style="margin-top:8px">Load next now</button>
    `;
    document.body.appendChild(panel);
    panel.querySelector('#inf-next').addEventListener('click', loadNextPage);
    setInterval(()=>{ const c=panel.querySelector('#inf-count'); if(c) c.textContent=productCount(); }, 500);
  }
})();
